const DEFAULT_RETRY_DELAY_MS = 30_000;
const MAX_TIMEOUT_MS = 2_147_483_647;

export const getRetryAfterDelay = (header: string | null): number => {
	if (header !== null && /^\d+$/.test(header.trim())) {
		const seconds = Number(header);
		if (Number.isSafeInteger(seconds) && seconds <= 2_147_483_647) {
			return seconds * 1000;
		}
	}
	return DEFAULT_RETRY_DELAY_MS;
};

// Long Retry-After values must not overflow the browser timer and retry immediately.
export const scheduleAfter = (notBefore: number, callback: () => void): (() => void) => {
	let timer: ReturnType<typeof setTimeout>;
	const schedule = () => {
		const remaining = notBefore - Date.now();
		if (remaining <= 0) {
			callback();
			return;
		}
		timer = setTimeout(schedule, Math.min(remaining, MAX_TIMEOUT_MS));
	};
	schedule();
	return () => clearTimeout(timer);
};
